import { render, staticRenderFns } from "./PreEmployeeModal.vue?vue&type=template&id=0c940470&"
import script from "./PreEmployeeModal.vue?vue&type=script&lang=js&"
export * from "./PreEmployeeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c940470')) {
      api.createRecord('0c940470', component.options)
    } else {
      api.reload('0c940470', component.options)
    }
    module.hot.accept("./PreEmployeeModal.vue?vue&type=template&id=0c940470&", function () {
      api.rerender('0c940470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/CustomerMgt/modules/PreEmployeeModal.vue"
export default component.exports